import { useMutation } from '@tanstack/react-query'

// Not apiFetch: the server puts the failure reason in the body of a non-ok
// response, and apiFetch throws it away.
const fellowRequest = async (url, method, body) => {
  const response = await fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data?.message || response.statusText)
  }

  return data
}

export const useCreateFellow = () =>
  useMutation({
    mutationFn: (fellow) => fellowRequest('/api/user/fellows', 'POST', fellow),
  })

export const useDeleteFellow = () =>
  useMutation({
    mutationFn: (fellow) =>
      fellowRequest(`/api/user/fellows/${fellow.id}`, 'DELETE'),
  })
